// extracted by mini-css-extract-plugin
var _1 = "CalendarSettingsFormSkeleton-moduleCalendarSettingsFormSkeleton__M2ulR CalendarSettingsForm-moduleCalendarSettingsForm__WA4lF";
var _2 = "CalendarSettingsFormSkeleton-modulebody___WfVo SettingsFormSectionContent-modulebody__Hug4g";
var _3 = "CalendarSettingsFormSkeleton-moduleswitchField__iFyS3 SettingsField-moduleSettingsField__fY88b Field-moduleField__kZH_K";
export { _1 as "CalendarSettingsFormSkeleton", _2 as "body", _3 as "switchField" }
